import { render, staticRenderFns } from "./SellersVips.vue?vue&type=template&id=2167f69a&scoped=true&"
import script from "./SellersVips.vue?vue&type=script&lang=js&"
export * from "./SellersVips.vue?vue&type=script&lang=js&"
import style0 from "./SellersVips.vue?vue&type=style&index=0&id=2167f69a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2167f69a",
  null
  
)

export default component.exports